import {_api, URLparams} from "@src/js/msp/api.js";
import { env } from "@mixins/environment.js"
import _funzioni from "@src/js/msp/funzioni.js"
import _calendario from "@src/js/vue/mixins/calendario.js";
import _storage from "@mixins/storage.js"
import _ums from "@cached/um.json"
import MSPFormatter from "@shared/msp/formatter.js";

let auth_token = _storage.getAuthToken();

const setAuthToken = function (at) {
    auth_token = at;
}

const sortByDate = function (ymdA, ymdB) {
    const dateA = new Date(ymdA);
    const dateB = new Date(ymdB);
    return (dateA < dateB) ? -1 : 1;

}

const formatterDate = function (value, field, headers) {
    void(field);
    void(headers);
    return _calendario.ymd2dateShort(value);
}


const ums = {
    'distanza': {
        umSegmento: 'mt',
        umRisultato: 'minkm',
    },
    'cp-ciclismo' : {
        mneSegmento: 'cp-ciclismo',
        umSegmento: 'min',
        umRisultato: 'w',
    },
};

function getUmFromMneSegmento (mneSegmento) {
    return ums[mneSegmento];
}

const makeRecord = function (data) {
    return data.sort(sortByDate).map((el)=>{
        const formatted = {
            ...el,
        };
        const extra = formatRisultato(el);
        for(let key in extra){
            const ex = extra[key];
            if (!ex.value) {
                formatted[key] = "-";
                continue;
            }
            if (ex.suffix) {
                formatted[key] = `${ex.value} ${ex.suffix}`;
                continue;
            }
            formatted[key] = `${ex.value}`;
        }

        return formatted;
    });
}

export const configBest = [
    {
        color: '#ffd700',
        background: '#ffd70055',
        classifica: '1st',
        badge: "1",
    },
    {
        color: '#c0c0c0',
        background: '#c0c0c055',
        classifica: '2nd',
        badge: "2",
    },
    {
        color: '#cd7f32',
        background: '#cd7f3255',
        classifica: '3th',
        badge: "3",
    },
];
export const headers = [
    {
        label: "Data",
        value: "data",
        field: "data",
        type: "date",
        sort: sortByDate,
        align: "left",
        string: formatterDate,
    },
    {
        label: "Risultato",
        value: "risultato",
        field: "risultato",
        type: "number",
        align: "right",
        string: "stringRisultato",
    },
    {
        label: "Passo",
        value: "risultato",
        field: "passo",
        type: "number",
        align: "left",
        string: "stringPasso",
    },
    {
        label: "Watt/kg",
        value: "risultato",
        field: "wattkg",
        type: "number",
        string: "wattkg",
        align: "left",
        suffix: "w/kg",
    },
    {
        label: "Record",
        value: "segmento",
        field: "segmento",
        type: "number",
        string: "segmento",
    },
];

const headersTipoRecord = {
    "best": [
        "segmento",
        "risultato",
        "data",
    ],
    "distanza": [
        "data",
        "risultato",
        "passo",
    ],
    "cp-ciclismo": [
        "data",
        "risultato",
        "wattkg",
    ],
}
const headersTipoTabella = {
    "best": { 
        "distanza": "best",
        "cp-ciclismo": "best",
    },
    "analisi": { 
        "distanza": "distanza",
        "cp-ciclismo": "cp-ciclismo",
    },
}

export const headersByTipoTabellaRecord = function (tipoTabella, tipoRecord) {
    if (Object.keys(headersTipoTabella).indexOf(tipoTabella) === -1) return [];
    if (Object.keys(headersTipoTabella[tipoTabella]).indexOf(tipoRecord) === -1) return [];
    const key = headersTipoTabella[tipoTabella][tipoRecord];
    const keys = headersTipoRecord[key];
    let filtered = keys.map((el)=>{
        const um = getUmFromMneSegmento(tipoRecord);
        const header = headers.find(h=>h.field===el);
        if (!header.um) {
            header.um = um.umRisultato;
        }
        return header;
    });
    return filtered;
}

export const headersByTipoRecord = function (tipoRecord) {
    if (Object.keys(headersTipoRecord).indexOf(tipoRecord) === -1) return [];
    const keys = headersTipoRecord[tipoRecord];
    let filtered = keys.map((el)=>{
        const um = getUmFromMneSegmento(tipoRecord);
        const header = headers.find(h=>h.field===el);
        if (!header.um) {
            header.um = um.umRisultato;
        }
        return header;
    });
    return filtered;
}

export const getSport = function (codice) {
    let sport = sports.find(el=>el.value==codice);
    return sport;
};

export const getSportById = function (sport_id) {
    let sport = sports.find(el=>el.sport_id==sport_id);
    return sport;
};

export const sports = [
    {
        "value": "CICLISMO",
        "label": "Ciclismo",
        "tipo_record": "cp-ciclismo",
        "tipo": "power",
        "sport_id": 2,
        "order": "desc",
    },
    {
        "value": "PODISMO",
        "label": "Podismo",
        "tipo_record": "distanza",
        "tipo": "speed",
        "sport_id": 1,
        "order": "asc",
    },

];

function aggiungiAnniListaPeriodi (listaPeriodi, anni) {
    const currentYear = new Date().getFullYear();
    for (let i=0; i<anni; i++) {
        let anno = String(currentYear - i);
        const periodo = {
            value: anno,
            text: anno,
        }
        if (listaPeriodi.map(el=>el.value).indexOf(periodo.value) === -1) {
            listaPeriodi.push(periodo);
        }
    }
}

function makeListaPeriodi () {

    const listaPeriodi = [
        {
            value: 'ALL',
            text: "All time",
        },
        {
            value: '90gg',
            text: "90 giorni",
        }
    ];
    return listaPeriodi;
}

export const listaPeriodi = makeListaPeriodi();

const loadCountRecord = function (atletaId) {
    if (!atletaId) return false;

    let data = {
        count: 1,
        atleta_id: atletaId,
    }
    let params = URLparams(data);
    let url = env.api_base_url+`/api/v2/record.php?${params}`;

    return new Promise((resolve,reject)=>{
        _api(url,'get',null,auth_token)
            .then((result)=>{
                if (result.success) {
                    resolve(result.data);
                } else {
                    resolve(null);
                }
            })
            .catch((error)=>{
                reject(error);
            })
    });
}

export const formatRisultato = function (item) {
    const formatters = {
        "distanza" : (item, key) => {
            return _funzioni.sec2hms_auto(item[key]);
        },
        "cp-ciclismo": (item, key)=>{
            const ums = {
                'risultato': 'w',
                'dettaglio': 'wkg',
            }
            const umCodice = ums[key];
            const um = _ums.find(el=>el.codice === umCodice);
            return _funzioni.round(item[key], um.decimali);
        },
    };
    const segmento = item.segmento;
    let dettaglioUm;
    if (item.dettaglio_um_id) {
        dettaglioUm = _ums.find(el=>el.id == item.dettaglio_um_id);
    } else {
        dettaglioUm = {
            "suffix": "",
        }
    }
    let formatter = formatters[item.mne] || null;


    let result = {};
    if (item.mne == 'distanza') {
        const umCodice = (segmento < 1000) ? "mt" : "km";
        const um = _ums.find(el=>el.codice === umCodice);
        if ("segmento" in item) {
            result.stringSegmento = {
                value: segmento / um.conversione,
                label: 'Segmento',
                key: 'stringSegmento',
                um: um.codice,
                suffix: um.suffix
            };
        }
        if ("risultato" in item) {
            result.stringRisultato = {
                value: formatter(item, 'risultato'),
                label: 'Risultato',
                suffix: ""
            };
            result.passo = {
                value: item.dettaglio,
                label: 'Passo',
                suffix: dettaglioUm.suffix,

            };
            result.stringPasso = {
                value: formatter(item, 'dettaglio'),
                label: 'Tempo',
                suffix: dettaglioUm.suffix,
            };
        }
        if ("bestAnno" in item) {
            result.stringBestAnno = {
                value: formatter(item.bestAnno),
                label: 'Tempo',
            };
        }


        if ("bestAllTime" in item) {
            result.stringBestAllTime = {
                value: formatter(item.bestAllTime),
                label: 'Tempo',
            };
        }
    } else if (item.mne == 'cp-ciclismo') {
        const umCodice = "w";
        const um = _ums.find(el=>el.codice === umCodice);
        if ("risultato" in item) {
            result.stringRisultato = {
                value: formatter(item, 'risultato'),
                label: 'Risultato',
                key: 'stringRisultato',
                suffix: um.suffix,
            };
        }
        if ("segmento" in item) {
            result.stringSegmento = {
                value: _funzioni.sec2hms_compact(item.segmento, (item.segmento < 3600)),
                label: 'Segmento',
                key: 'stringSegmento',
                suffix: "",
            };
        }
        if ("bestAllTime" in item) {
            result.stringRisultato = {
                value: item.risultato,
                label: 'Risultato',
                key: 'stringRisultato',
                suffix: um.suffix,
            };
        }
        if ("dettaglio" in item) {
            result.wattkg = {
                value: item.dettaglio,
                label: 'Dettaglio',
                key: 'dettaglio',
                suffix: dettaglioUm.suffix,
            }
        }
        if ("bestAllTime" in item) {
            result.stringBestAllTime = {
                value: item.bestAllTime,
                label: 'Risultato',
                suffix: um.suffix,
            };
        }


    }

    if (item.dettaglio) {
        result.stringDettaglio = {
            value: formatter(item, 'dettaglio'),
            suffix: dettaglioUm.suffix,
        }
    } else {
        result.stringDettaglio = {
            value: "",
            suffix: "",
        }
    }

        return result;
}
const grandezze = [
    {
        value: (val)=>(val),
        um: 'mt',
    },
    {
        value: (val)=>(MSPFormatter.arrotonda(val/1000, 1)),
        um: 'km',
    },
];
const formatGrandezzaDistanza = function (mt) {
    const iGrandezza = (mt < 1000) ? 0 : 1;
    const grandezza = grandezze[iGrandezza];
    const value = grandezza.value(mt);
    const um = grandezza.um;
    return {
        value: value,
        um: um,
    }
}
export default {
    formatGrandezzaDistanza,
    sortByDate,
    headers,
    headersByTipoTabellaRecord,
    headersByTipoRecord,
    getSport,
    getSportById,
    sports,
    listaPeriodi,
    aggiungiAnniListaPeriodi,
    loadCountRecord,
    formatRisultato,
    configBest,
    makeRecord,
    setAuthToken,
}
